import { AdvancedFilterDataSchema } from "@redotech/redo-model/views/views";
import * as z from "zod/v4";

export enum CatalogFilterName {
  SALES_CHANNEL = "salesChannel",
  STATUS = "status",
  VENDOR = "vendor",
  SKU = "sku",
  PRICE_RANGE = "priceRange",
}

export const getCatalogUniqueValues = {
  name: "getCatalogUniqueValues" as const,
  input: z.object({
    filterName: z.enum(CatalogFilterName),
    filterSearch: z.string().optional(),
    advancedFiltersData: z.array(AdvancedFilterDataSchema).optional(),
    limit: z.number().min(1).max(500).default(100).optional(),
  }),
  output: z.object({
    values: z.array(z.string()),
    totalCount: z.number(),
    hasMore: z.boolean(),
  }),
};
